import { render, staticRenderFns } from "./NavbarTopActivityQuizEdit.vue?vue&type=template&id=2603df09"
import script from "./NavbarTopActivityQuizEdit.vue?vue&type=script&lang=js"
export * from "./NavbarTopActivityQuizEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports